export enum HobbyAudienceEnum {
  ENROLLMENT = 'ENROLLMENT',
  STAFF = 'STAFF'
}

export const hobbyAudienceEnumMapping: Record<HobbyAudienceEnum, string> = {
  [HobbyAudienceEnum.ENROLLMENT]: 'Espace client',
  [HobbyAudienceEnum.STAFF]: 'Encadrant'
}
